export const chapterDisplayCacheEntryLifetimeInMilliseconds = 2 * 60 * 1000
export const maximumCachedChapterDisplays = 250
export const chapterDisplayConcurrencyLimit = 4
export const defaultCacheScope = 'default'
